/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendD8ByProductResponseDto } from '../models/backend-d-8-by-product-response-dto';
import { BackendD8GridResponseDto } from '../models/backend-d-8-grid-response-dto';
import { BackendD8TotalResponseDto } from '../models/backend-d-8-total-response-dto';
import { getByProductDashboardsD8ByProductGet } from '../fn/dashboards/get-by-product-dashboards-d-8-by-product-get';
import { GetByProductDashboardsD8ByProductGet$Params } from '../fn/dashboards/get-by-product-dashboards-d-8-by-product-get';
import { getGridDashboardsD8GridGet } from '../fn/dashboards/get-grid-dashboards-d-8-grid-get';
import { GetGridDashboardsD8GridGet$Params } from '../fn/dashboards/get-grid-dashboards-d-8-grid-get';
import { getTotalDashboardsD8TotalGet } from '../fn/dashboards/get-total-dashboards-d-8-total-get';
import { GetTotalDashboardsD8TotalGet$Params } from '../fn/dashboards/get-total-dashboards-d-8-total-get';

@Injectable({ providedIn: 'root' })
export class BackendApiD8Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getByProductDashboardsD8ByProductGet()` */
  static readonly GetByProductDashboardsD8ByProductGetPath = '/dashboards/d8/by-product';

  /**
   * D8: динамика продаж по продуктам (для стэкбара).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByProductDashboardsD8ByProductGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByProductDashboardsD8ByProductGet$Response(
    params: GetByProductDashboardsD8ByProductGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD8ByProductResponseDto>> {
    return getByProductDashboardsD8ByProductGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8: динамика продаж по продуктам (для стэкбара).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByProductDashboardsD8ByProductGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByProductDashboardsD8ByProductGet(
    params: GetByProductDashboardsD8ByProductGet$Params,
    context?: HttpContext,
  ): Observable<BackendD8ByProductResponseDto> {
    return this.getByProductDashboardsD8ByProductGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD8ByProductResponseDto>): BackendD8ByProductResponseDto => r.body),
    );
  }

  /** Path part for operation `getTotalDashboardsD8TotalGet()` */
  static readonly GetTotalDashboardsD8TotalGetPath = '/dashboards/d8/total';

  /**
   * D8: суммарный план продаж (для общей линии и итоговой панели).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalDashboardsD8TotalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalDashboardsD8TotalGet$Response(
    params: GetTotalDashboardsD8TotalGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD8TotalResponseDto>> {
    return getTotalDashboardsD8TotalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8: суммарный план продаж (для общей линии и итоговой панели).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalDashboardsD8TotalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalDashboardsD8TotalGet(
    params: GetTotalDashboardsD8TotalGet$Params,
    context?: HttpContext,
  ): Observable<BackendD8TotalResponseDto> {
    return this.getTotalDashboardsD8TotalGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD8TotalResponseDto>): BackendD8TotalResponseDto => r.body),
    );
  }

  /** Path part for operation `getGridDashboardsD8GridGet()` */
  static readonly GetGridDashboardsD8GridGetPath = '/dashboards/d8/grid';

  /**
   * D8: полная таблица «продукт × месяц» + итоговая строка.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGridDashboardsD8GridGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGridDashboardsD8GridGet$Response(
    params: GetGridDashboardsD8GridGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD8GridResponseDto>> {
    return getGridDashboardsD8GridGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8: полная таблица «продукт × месяц» + итоговая строка.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGridDashboardsD8GridGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGridDashboardsD8GridGet(
    params: GetGridDashboardsD8GridGet$Params,
    context?: HttpContext,
  ): Observable<BackendD8GridResponseDto> {
    return this.getGridDashboardsD8GridGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD8GridResponseDto>): BackendD8GridResponseDto => r.body),
    );
  }
}
